<template>
	<div class="cancel">
		<a class="btn btn--white" v-on:click="showAlert()">
			<span class="d-none d-md-block">
				Cancel
			</span>
		</a>
	</div>
</template>




<script>
    
    export default {
        name: 'Cancel',
       
        
        methods: {

            showAlert() {
                // Use sweetalert2
                this.$swal.fire({
                    title: 'Are you sure?',
                    text: "You will have to start over!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#a10000',
                    cancelButtonColor: '#425261',
   
                    confirmButtonText: 'Cancel booking',
                    cancelButtonText: 'Continue booking'
                }).then((result) => {
                    if (result.isConfirmed) {
                        window.location.href = '/';
                    }
                })
            }, 
        }
    }
</script>

<style>
    .swal2-styled.swal2-confirm, .swal2-cancel.swal2-styled{
        text-transform: uppercase;
        font-weight: bold;
    }
</style>